import type { CrmChildRow } from '../ChildList/CrmChildListStore'

/**
 * Підписи полів договору CRM (`SPEC-008` §4.3) — тексти легасі
 * (`ClientContractResource.js:6-29`, `uk.json:549-550,582,118`).
 */
export const CRM_CONTRACT_FIELD_LABELS = {
    number: 'Номер договору',
    date: 'Дата договору',
    forwarder: 'Експедитор',
    file: 'Файл',
    createdAt: 'Дата створення',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const

/**
 * Типи файлу договору — білий список беку (`CrmFileMimePolicy`, `SPEC-008`
 * §5.7.2). Бек перевіряє і розширення, і вміст; тут — лише підказка вибору
 * файлу й рання відмова до завантаження.
 */
export const CRM_CONTRACT_FILE_EXTENSIONS = [
    'docx',
    'dotx',
    'xlsx',
    'xltx',
    'pptx',
    'ppsx',
    'potx',
    'sldx',
    'oxt',
    'pdf',
    'gif',
    'jpg',
    'jpeg',
    'jp2',
    'png',
    'webp',
    'heic',
]

/**
 * Межа розміру файлу CRM, МБ: ядровий nginx більше 10 МБ не пропускає
 * (`SPEC-008` §5.7.3, Р-5), хоча `FileUploadValidator` беку дозволив би 25.
 */
export const CRM_FILE_MAX_SIZE_MB = 10

/** Договір так, як його віддає колекція (`crm_contract:collection:read`). */
export interface CrmContractRow extends CrmChildRow {
    /** «№ <номер> від <дд.мм.рррр>» — назва вкладеного об'єкта */
    title?: string | null
    number?: string | null
    date?: string | null
    forwarder?: { '@id'?: string; title?: string | null } | null
    file?: unknown
}
